import { useMutation } from '@tanstack/react-query';
import { api } from 'src/services';

export type UploadCSVPayload = {
  s3_key: string;
  body: string;
  content_type: string;
};

export type UploadCSVResponse = {
  message?: string;
};

export const useUploadAppointmentCSV = () => {
  return useMutation({
    mutationKey: ['uploadAppointmentCSV'],
    mutationFn: (payload: UploadCSVPayload) =>
      api
        .post<UploadCSVResponse>('/upload_csv', payload)
        .then((res) => res.data),
  });
};
